import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const token = localStorage.getItem("token");
    // backend publicado num subcaminho (ex.: https://hub.../api/): o socket.io
    // usa a origem + "<caminho>/socket.io", senão o caminho viraria namespace
    const url = new URL(getBackendUrl(), window.location.href);
    return openSocket(url.origin, {
      path: `${url.pathname.replace(/\/$/, "")}/socket.io`,
      transports: ["websocket", "polling", "flashsocket"],
      query: {
        token: JSON.parse(token),
      },
    });
}

export default connectToSocket;
